import MainLayout from "../layout/mainLayout";
export default function Customers() {
    return (
        <MainLayout
            pageTitle='ลูกค้า'
            disableFrom={true}
        />
    );
}